// Libs
import React from 'react';
import { useSelector } from 'react-redux';
// Context
import { useComponentsPool } from '../../../ComponentsPool';
import { isMobile } from 'react-device-detect';
import { isNewSystem } from '../../../switch';

const DeviceActionButton = () => {
  const { Component } = useComponentsPool();
  const userRole = useSelector(state => state.users.currentUser.workspace_role?.workspace_role_name);
  const canImportDevices = userRole === 'Owner' && !isNewSystem();
  if (isMobile) return <></>;

  return (
    <Component
      componentName={'ActionButton'}
      canUserCreate={canImportDevices}
      modalName={'DeviceAddPopup'}
      iconButton={(<Component componentName={'Icon'} type={'device'} />)}
      tooltipTitle={'devices:add_devices'}
    />
  );
};

export default DeviceActionButton;
